module.exports = __webpack_public_path__ + "08cb8f79715774f9a6285ee7db2919a3.woff";